import utils from "../common/util";
import cmpTruthDareBtn from "./cmp-truth-dare-btn";
import cmpPlayerNameContainer from "./cmp-player-name-container";
import cmpPageHeader from "./cmp-page-header";

const cmpScoresPage = {
	component: null,

	init: function (element)
	{
		utils.log('cmpScoresPage initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.component = element;
		_.contentPanel = document.getElementById('inter-game-results');

		utils.setVariables(this);
	},

	hideScoresPanel: function ()
	{
		const _ = this;

		utils.oneTimeListener(_.contentPanel, 'transitionend', (e) =>
		{
			if (e.propertyName !== 'margin-top') return;

			utils.showHideElement(_.contentPanel, 'hide');
		});
		_.contentPanel.classList.add('inactive');


		utils.sleep(500).then(() =>
		{
			cmpTruthDareBtn.showTruthDareButtons();
			cmpPlayerNameContainer.showPlayerNameContainer();
			cmpPageHeader.showGameLevel();
		});
	},

	showScoresPanel: function ()
	{
		const _ = this;

		cmpTruthDareBtn.removeTruthDareButtons();
		cmpPlayerNameContainer.removePlayerNameContainer();
		cmpPageHeader.hideGameLevel();


		fetch(utils.getApiUrl() + '/game-results/' + _.gameId, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': 'Bearer ' + _.bearerToken
			}
		})
			.then(response => response.json())
			.then(data =>
			{
				let pageContent = '';

				for (let game_level of data.data) {
					pageContent += '<h2>' + game_level.name + '</h2>';
					pageContent += '<div class="inter-game-results__group-container">';

					for (let play of game_level.plays) {
						/** @namespace play.playResult.player */

						let resultMsg = 'Scores';
						let icon;
						let statusName;

						if (parseInt( play.playResult.taskCompleted) === 1) {
							resultMsg = 'Task Completed';
							icon = 'checkbox';
							statusName = 'completed';
						} else if (parseInt(play.playResult.opponentFailed) === 1) {
							resultMsg = 'Opponent Failed';
							icon = 'close-circle';
							statusName = 'failed';
						} else if (parseInt(play.playResult.playerFailed) === 1) {
							resultMsg = 'Player Failed';
							icon = 'close-circle';
							statusName = 'failed';
						}

						pageContent += '<div class="inter-game-results__play-container">';
						pageContent += '<div class="inter-game-results__player-name">' + play.playResult.player.name + '</div>';
						pageContent += '<div class="inter-game-results__play-result">' +
							'<ion-icon type="submit" class="icon-btn ' + statusName + ' md hydrated" name="' + icon + '" role="img"></ion-icon>'
							+ resultMsg + '</div>';
						pageContent += '<div class="final-game-results__play-action">' + play.action + '</div>'
						pageContent += '</div>';
					}
					pageContent += '</div>';
				}

				_.contentPanel.innerHTML = pageContent;
				utils.animateAndShow(_.contentPanel,'inactive');
			});
	}
}

export default cmpScoresPage;
